namespace TabAurous.Production {
    export namespace JobWorkReceiptTaxService {
        export const baseUrl = 'Production/JobWorkReceiptTax';

        export declare function Create(request: Serenity.SaveRequest<JobWorkReceiptTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<JobWorkReceiptTaxRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobWorkReceiptTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobWorkReceiptTaxRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/JobWorkReceiptTax/Create",
            Update = "Production/JobWorkReceiptTax/Update",
            Delete = "Production/JobWorkReceiptTax/Delete",
            Retrieve = "Production/JobWorkReceiptTax/Retrieve",
            List = "Production/JobWorkReceiptTax/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>JobWorkReceiptTaxService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
